import { DetailedHTMLProps, forwardRef, LabelHTMLAttributes, memo, ReactNode, useId } from "react";
import classNames from "classnames";
import { ToggleBase, ToggleBaseProps } from "../ToggleBase";

import styles from "./styles.module.scss";

export type ToggleSize = "sm" | "md";

export type ToggleProps = Omit<ToggleBaseProps, "toggleBaseSize"> & {
  toggleBaseClassName?: string,
  toggleSize?: ToggleSize,
  supportingText?: ReactNode,
  labelProps?: Omit<DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>, "className">
  text: ReactNode,
}

export const Toggle = memo(forwardRef<HTMLSpanElement, ToggleProps>((
  {
    toggleBaseClassName,
    toggleSize,
    text,
    supportingText,
    className,
    disabled,
    id,
    labelProps,
    ...props
  }, ref,
) => {
  const reactId = useId();
  const realId = id || reactId;

  return (
    <label
      {...labelProps}
      className={classNames(
        styles.root,
        className,
        styles[toggleSize as keyof typeof styles],
        {
          [styles.hasSupportingText]: !!supportingText,
          [styles.disabled]: disabled,
        },
      )}
      htmlFor={realId}
    >
      <ToggleBase
        ref={ref}
        toggleBaseSize={toggleSize}
        className={classNames(styles.toggleBase, toggleBaseClassName)}
        disabled={disabled}
        id={realId}
        {...props}
      />
      <span className={styles.text}>
        {text}
      </span>
      {
        !!supportingText &&
        <span className={styles.supportingText}>
          {supportingText}
        </span>
      }
    </label>
  );
}));